import React from 'react';

import { Confirm, type ConfirmComponentName } from '../../constants';
import DeleteConfirm from './DeleteConfirm';

export type ConfirmOptions = {
  componentName: ConfirmComponentName;
  props: {
    onConfirm?: () => void;
    projectDatabaseId?: number;
  };
};

type ConfirmRootProps = {
  cancelConfirm: () => void;
  confirm: ConfirmOptions;
  onSuccessfulDelete?: () => void;
};

const ConfirmRoot = ({
  confirm,
  cancelConfirm,
  onSuccessfulDelete,
}: ConfirmRootProps) => {
  const { componentName, props: confirmProps } = confirm;
  switch (componentName) {
    case Confirm.DELETE:
      return (
        <DeleteConfirm
          projectDatabaseId={confirmProps?.projectDatabaseId}
          cancelConfirm={cancelConfirm}
          onSuccessfulDelete={onSuccessfulDelete}
        />
      );
    default:
      return null;
  }
};

export default ConfirmRoot;
